/**
 *
 * @param {Object} state
 * @param {String} email
 */
const SET_CHECKOUT_INFO_DATA_REQUIRED = (state, payload) => {
  if (typeof(payload.data) === "boolean") {
    state.checkout.required.infos[payload.type] = payload.data
  } else {
    payload.data != ""
      ? (state.checkout.required.infos[payload.type] = payload.data)
      : (state.checkout.required.infos[payload.type] = "");
  }
};

const SET_CHECKOUT_RENTING_INFO_DATA_REQUIRED = (state, payload) => {
    if (typeof(payload.data) === "boolean") {
        state.checkout.required_renting.infos[payload.type] = payload.data
    } else {
        payload.data != ""
            ? (state.checkout.required_renting.infos[payload.type] = payload.data)
            : (state.checkout.required_renting.infos[payload.type] = "");
    }
};

/**
 *
 * @param {Object} state
 * @param {Object} payload
 */
const SET_CHECKOUT_INFO_OPTIONAL = (state, payload) => {
  payload.data != ""
    ? (state.checkout.optional.infos[payload.type] = payload.data)
    : (state.checkout.optional.infos[payload.type] = "");
};

/**
 *
 * @param {Object} state
 * @param {String} email
 */
const SET_CHECKOUT_FILL_PERCENT = (state, percent) => {
  percent != "" ? (state.checkout.fillPercent = percent) : false;
};

const SET_OPTIN_DATA = (state, payload) => {
  state.checkout.required.infos.proxiserve_optin = payload;
}

export default {
  SET_CHECKOUT_INFO_DATA_REQUIRED,
  SET_CHECKOUT_FILL_PERCENT,
  SET_CHECKOUT_INFO_OPTIONAL,
  SET_CHECKOUT_RENTING_INFO_DATA_REQUIRED,
  SET_OPTIN_DATA
};
